import { useNavigate } from 'react-router-dom';
import { Button } from 'antd-mobile';
import { ArrowRight } from 'lucide-react';
import tangtungRich from '../assets/tangtung-rich.jpg';
import './OnboardingPage.css';

export default function OnboardingPage() {
    const navigate = useNavigate();

    const handleStart = () => {
        // Navigate to main app (Mini POS or Calculator)
        navigate('/calculator');
    };

    return (
        <div className="onboarding-page">
            {/* Background Glows */}
            <div className="onboarding-glow glow-left"></div>
            <div className="onboarding-glow glow-right"></div>

            <div className="onboarding-content">
                {/* Brand Title */}
                <div className="brand-title">TangTung POS</div>

                {/* Step Badge */}
                <div className="step-badge">STEP 1</div>

                {/* Mascot Image */}
                <div className="mascot-container">
                    <img
                        src={tangtungRich}
                        alt="น้องตังค์ตุง"
                        className="mascot-image"
                    />
                </div>

                {/* Main Text */}
                <h1 className="main-title">
                    คิดเงินปุ๊บ<br />
                    <span className="highlight-text">เจน QR ปั๊บ!</span>
                </h1>

                {/* Description */}
                <p className="sub-description">
                    เลิกจำเลขบัญชี! แค่กดเครื่องคิดเลข
                    ก็สร้าง QR PromptPay พร้อมยอดเงิน
                    ให้ลูกค้าสแกนจ่ายได้ทันที
                </p>

                {/* CTA Button */}
                <Button
                    className="start-btn"
                    onClick={handleStart}
                >
                    เริ่มให้ผมช่วยงานเลย!
                    <ArrowRight className="btn-icon" size={20} style={{ marginLeft: 4 }} />
                </Button>
            </div>
        </div>
    );
}
